<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'system-sysQuartzTask',
  components: {
    PageTable,
  },
}
</script>
